import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { Subtract } from 'utility-types'

const useBrandName = () => 'GUIDEcx'

export interface WithBrandNameProps {
  brandName: string
}

export const withBrandName = <P extends WithBrandNameProps>(
  Component: React.ComponentType<P>,
) => {
  const BrandedComponent = React.forwardRef<
    any,
    Subtract<P, WithBrandNameProps>
  >((props, ref) => (
    <Component
      {...(props as unknown as P)}
      ref={ref}
      brandName={useBrandName()}
    />
  ))

  return hoistNonReactStatics(BrandedComponent, Component)
}

export default useBrandName
